// extracted by mini-css-extract-plugin
export default {"drawerItem":"main-menu-collapse-header_drawerItem__kww-V"};